import { Bot, Sparkles } from 'lucide-react';
import Layout from '@/components/Layout';

const SUGGESTIONS = [
  "Tips agar hafalan kuat",
  "Doa sebelum menghafal",
  "Cara murajaah efektif",
  "Keutamaan hafal Quran",
];

export default function ChatbotPage() {
  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-br from-emerald-950 via-emerald-800 to-emerald-700 px-5 pt-12 pb-6 relative overflow-hidden flex-shrink-0">
          <div className="absolute -top-8 -right-8 w-36 h-36 bg-white/5 rounded-full pointer-events-none" />
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-2xl bg-white/15 flex items-center justify-center ring-1 ring-white/20">
              <Bot size={22} className="text-white" />
            </div>
            <div>
              <h1 className="font-bold text-white text-lg leading-tight">Chatbot ZahBaq</h1>
              <p className="text-[11px] text-emerald-200 mt-0.5">Asisten AI Hafalan Al-Quran</p>
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="flex-1 flex flex-col items-center justify-center px-6 py-10 text-center">
          {/* Icon */}
          <div className="relative mb-6">
            <div className="w-24 h-24 rounded-3xl bg-emerald-100 flex items-center justify-center">
              <Bot size={44} className="text-emerald-500" />
            </div>
            <span className="absolute -top-1 -right-1 w-7 h-7 bg-amber-400 rounded-full flex items-center justify-center shadow-md">
              <Sparkles size={13} className="text-white" />
            </span>
          </div>

          <h2 className="text-xl font-bold text-gray-800 mb-2">Segera Hadir</h2>
          <p className="text-sm text-gray-500 max-w-xs leading-relaxed mb-6">
            Chatbot AI siap membantu perjalanan hafalan Anda — tanyakan apa saja tentang Al-Quran, tips menghafal, dan jadwal setoran.
          </p>

          {/* Suggestion chips */}
          <div className="flex gap-2 flex-wrap justify-center mb-8">
            {SUGGESTIONS.map(s => (
              <span key={s}
                className="px-3.5 py-1.5 bg-white text-emerald-700 rounded-full text-xs font-semibold border border-emerald-100 shadow-sm">
                {s}
              </span>
            ))}
          </div>

          {/* Coming soon badge */}
          <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-100 rounded-2xl px-5 py-3">
            <span className="w-2 h-2 bg-amber-400 rounded-full animate-pulse" />
            <span className="text-xs font-semibold text-emerald-700">Fitur ini sedang dalam pengembangan</span>
          </div>
        </div>
      </div>
    </Layout>
  );
}
